import React, { useEffect, useState } from "react";
import "./Gallery.css";

const galleryImages = [
  { id: 1, src: "/gallery/gallery1.png", alt: "Therapy Session 1" },
  { id: 2, src: "/gallery/gallery2.png", alt: "Therapy Session 2" },
  { id: 3, src: "/gallery/gallery3.png", alt: "Therapy Session 3" },
  { id: 4, src: "/gallery/gallery4.png", alt: "Therapy Session 4" },
  { id: 5, src: "/gallery/gallery5.png", alt: "Therapy Session 5" },
  { id: 6, src: "/gallery/gallery6.png", alt: "Therapy Session 6" },
  { id: 7, src: "/gallery/gallery7.png", alt: "Therapy Session 7" },
  { id: 8, src: "/gallery/gallery8.png", alt: "Therapy Session 8" },
  { id: 9, src: "/gallery/gallery9.png", alt: "Therapy Session 9" },
  { id: 10, src: "/gallery/gallery10.png", alt: "Therapy Session 10" },
  { id: 11, src: "/gallery/gallery11.png", alt: "Therapy Session 11" },
  { id: 12, src: "/gallery/gallery12.png", alt: "Therapy Session 12" },
  { id: 13, src: "/gallery/gallery13.png", alt: "Therapy Session 13" },
  { id: 14, src: "/gallery/gallery14.png", alt: "Therapy Session 14" },
  { id: 15, src: "/gallery/gallery15.png", alt: "Therapy Session 15" },
  { id: 16, src: "/gallery/gallery16.png", alt: "Therapy Session 16" },
  { id: 17, src: "/gallery/gallery17.png", alt: "Therapy Session 17" },
  { id: 18, src: "/gallery/gallery18.png", alt: "Therapy Session 18" },
  { id: 19, src: "/gallery/gallery19.png", alt: "Therapy Session 19" },
  { id: 20, src: "/gallery/gallery20.png", alt: "Therapy Session 20" },
  { id: 21, src: "/gallery/gallery21.png", alt: "Therapy Session 21" },
  { id: 22, src: "/gallery/gallery22.png", alt: "Therapy Session 22" },
  { id: 23, src: "/gallery/gallery23.png", alt: "Therapy Session 23" },
  { id: 24, src: "/gallery/gallery24.png", alt: "Therapy Session 24" },
  { id: 25, src: "/gallery/gallery25.png", alt: "Therapy Session 25" },
  { id: 26, src: "/gallery/gallery26.png", alt: "Therapy Session 26" },
  { id: 27, src: "/gallery/gallery27.png", alt: "Therapy Session 27" },
];

export default function Gallery() {
  useEffect(() => {
    document.title = "Gallery | Gifted Child Therapy";
  }, []);

  const [selectedImage, setSelectedImage] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);

  const openImage = (image) => {
    setSelectedImage(image);
    setZoomLevel(1);
    document.body.style.overflow = "hidden"; // disable background scroll
  };

  const closeImage = () => {
    setSelectedImage(null);
    document.body.style.overflow = "auto";
  };

  const handleZoom = (e) => {
    e.preventDefault();
    const zoom = zoomLevel + e.deltaY * -0.001; // smooth zoom
    if (zoom > 0.5 && zoom < 5) setZoomLevel(zoom);
  };

  return (
    <div className="gallery-container">
      {/* Banner Image */}
      <div className="gallery-banner">
        <img src="/galleryBanner.png" alt="Gallery Banner" className="banner-img" />
      </div>

      {/* Masonry Gallery */}
      <div className="gallery-masonry">
        {galleryImages.map((img) => (
          <div key={img.id} className="gallery-card">
            <img
              src={img.src}
              alt={img.alt}
              className="gallery-img"
              onClick={() => openImage(img)}
            />
          </div>
        ))}
      </div>

      {/* Fullscreen Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImage}>
          <span className="close-btn" onClick={closeImage}>
            ✕
          </span>

          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="modal-img"
            style={{ transform: `scale(${zoomLevel})` }}
            onWheel={handleZoom}
            onClick={(e) => e.stopPropagation()} // prevent close on clicking the image
          />
        </div>
      )}
    </div>
  );
}
